import React from "react";

interface DownArrowMinimalProps {
  height?: number;
  width?: number;
  strokeColor?: string;
}

/**
 * Compact down-arrow chevron used in collapsed/expandable UI.
 *
 * @param props - Optional SVG sizing and stroke color
 * @param props.height - Rendered height in pixels (defaults to 7)
 * @param props.width - Rendered width in pixels (defaults to 12)
 * @param props.strokeColor - Path stroke color (defaults to #1A1A1A)
 * @returns Down-arrow SVG
 */
const DownArrowMinimal = ({
  height = 7,
  width = 12,
  strokeColor = "#1A1A1A",
}: DownArrowMinimalProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 7"
      fill="none"
    >
      <path
        d="M0.833344 0.833374L5.83334 5.83337L10.8333 0.833372"
        stroke={strokeColor}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DownArrowMinimal;
